import { SERVER_ERRORS_REGEX } from '../../constants';

export const ignoreErrors = [
  SERVER_ERRORS_REGEX,
  // Random plugins/extensions
  'top.GLOBALS',
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  'originalCreateNotification',
  'canvas.contentDocument',
  'MyApp_RemoveAllHighlights',
  'http://tt.epicplay.com',
  "Can't find variable: ZiteReader",
  'jigsaw is not defined',
  'ComboSearch is not defined',
  'http://loading.retry.widdit.com/',
  'atomicFindClose',
  // Facebook borked
  'fb_xd_fragment',
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
  // reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268
  'bmi_SafeAddOnload',
  'EBCallBackMessageReceived',
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  'conduitPage',
  'The network connection was lost.',
  'The Internet connection appears to be offline.',
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications.',
  'Failed to fetch',
  'Unauthorized',
  'Not authenticated. Please sign in.',
  'Object Not Found Matching Id',
  // https://crewmeister.sentry.io/issues/4275801004/?environment=production&project=245438&query=&referrer=issue-stream&sort=date&stream_index=0
  "SyntaxError: 'a[href^=blob:]' is not a valid selector",
  // https://crewmeister.sentry.io/issues/3467174017/?environment=production&project=245438&query=&referrer=issue-stream&sort=date&stream_index=1
  'SyntaxError: The string did not match the expected pattern',
  // https://crewmeister.sentry.io/issues/4976422345/?environment=production&project=245438&query=&referrer=issue-stream&sort=date&stream_index=2
  'Unknown error occurred (status code=401)',
  // https://crewmeister.sentry.io/issues/3471670189/?environment=production&project=245438&query=&referrer=issue-stream&sort=date&stream_index=3
  "SyntaxError: Failed to execute 'querySelector' on 'Document': 'a[href^=blob:]' is not a valid selector",
  // https://crewmeister.sentry.io/issues/5654945471/?environment=production&project=245438&query=&referrer=issue-stream&sort=date&stream_index=4
  'Unknown error occurred (TypeError: Load failed)',
];

export const blacklistUrls = [
  // Facebook flakiness
  /graph\.facebook\.com/i,
  // Facebook blocked
  /connect\.facebook\.net\/en_US\/all\.js/i,
  // Woopra flakiness
  /eatdifferent\.com\.woopra-ns\.com/i,
  /static\.woopra\.com\/js\/woopra\.js/i,
  // Chrome extensions
  /extensions\//i,
  /^chrome:\/\//i,
  // Other plugins
  /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
  /webappstoolbarba\.texthelp\.com\//i,
  /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
];
